import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { Table, TableModule } from 'primeng/table';
import { TreeTableModule } from 'primeng/treetable';
import { CheckboxModule } from 'primeng/checkbox';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';
import { ToolbarModule } from 'primeng/toolbar';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { FluidModule } from 'primeng/fluid';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { ConfirmationService } from 'primeng/api';

import { PackagesViewModel } from '../viewmodels/packages.viewmodel';
import { FuntionalAreaService } from '../../test-suite/services/test-suite.service';
import { ScenarioService } from '../../scenario/services/scenario.service';
import { PackagesService } from '../services/packages.service';
import { ToastService } from 'src/app/toast/toast.service';
import { AuthService } from '../../../auth/login/services/auth.service';

@Component({
  selector: 'app-packages',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    TableModule,
    TreeTableModule,
    CheckboxModule,
    ButtonModule,
    DialogModule,
    SelectModule,
    InputTextModule,
    TextareaModule,
    ToolbarModule,
    ConfirmDialogModule,
    ToastModule,
    TooltipModule,
    FluidModule,
    IconFieldModule,
    InputIconModule,
  ],
  templateUrl: './packages.component.html',
  styleUrl: './packages.component.scss',
  providers: [ConfirmationService]
})
export class PackagesComponent implements OnInit {
  private http = inject(HttpClient);
  private toastService = inject(ToastService);
  private confirmationService = inject(ConfirmationService);
  private packagesService = inject(PackagesService);
  private funtionalAreaService = inject(FuntionalAreaService);
  private scenarioService = inject(ScenarioService);
  private authService = inject(AuthService);

  public viewModel!: PackagesViewModel;
  @ViewChild('dt') dt!: Table;

  ngOnInit(): void {
    this.viewModel = new PackagesViewModel(
      this.http,
      this.toastService,
      this.confirmationService,
      this.packagesService,
      this.authService,
      this.funtionalAreaService,
      this.scenarioService
    );
    this.viewModel.init();
  }
}
